/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OfferRequestCreateResponse } from '../../models/offer-request-create-response';

export interface GetOfferRequestById$Params {
  offerRequestId: string;
}

export function getOfferRequestById(http: HttpClient, rootUrl: string, params: GetOfferRequestById$Params, context?: HttpContext): Observable<StrictHttpResponse<OfferRequestCreateResponse>> {
  const rb = new RequestBuilder(rootUrl, getOfferRequestById.PATH, 'get');
  if (params) {
    rb.path('offerRequestId', params.offerRequestId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OfferRequestCreateResponse>;
    })
  );
}

getOfferRequestById.PATH = '/offers/requests/{offerRequestId}';
